// @flow

export const isQueryAlertLanding = (alertLanding: number): boolean => alertLanding === 1;



// WEBPACK FOOTER //
// ./app/request/query/utils.js